module.exports = __webpack_public_path__ + "img/frais_medicaux.e7dbca4c.png";